<div class="sub-plan-associations-item-form">
  <input #input id="reportType"
    class="form-control"
    [class.disabled]="!isEditMode"
    [ngClass]="{'border-danger': isInvalid}"
    type="text"
    [placeholder]="itemPlaceholder"
    [value]="nameList"
    [matAutocomplete]="idItems"
    (keyup)="onChangeSearchedItem($event.target.value)"
    (input)="onInputChange()"
    >
  <mat-autocomplete #idItems="matAutocomplete" [displayWith]="displayItem">
    @for (item of items; track item) {
      <mat-option class="option-wrap" [value]="item" (click)="onClickAddDiffusionListName(item)">
        <span class="option-value">{{item?.nameList}}</span>
        <span class="btn-add icon-plus"></span>
      </mat-option>
    }
  </mat-autocomplete>
</div>
@if (isInvalid) {
  <div class="alert alert-danger">
    <div>
      {{'error.is_required' | translate}}
    </div>
  </div>
}
@if (!!nameList && notFound) {
  <div class="alert alert-danger">
    <div>
      {{'error.not_found' | translate}}
    </div>
  </div>
}